import { render, staticRenderFns } from "./HalfWidthBlock.vue?vue&type=template&id=07542912&scoped=true&"
import script from "./HalfWidthBlock.vue?vue&type=script&lang=ts&"
export * from "./HalfWidthBlock.vue?vue&type=script&lang=ts&"
import style0 from "./HalfWidthBlock.vue?vue&type=style&index=0&id=07542912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07542912",
  null
  
)

export default component.exports